export const CommissionsWizard = {
	GetStarted: {
		value: 0,
		name: "get-started",
		displayName: "Get Started",
	},
	FileUploadDataMapping: {
		value: 1,
		name: "file-upload-data-mapping",
		displayName: "File Upload & Data Mapping",
	},
	FeeItems: {
		value: 2,
		name: "fee-items",
		displayName: "Fee Items",
	},
	ScheduleTemplate: {
		value: 3,
		name: "schedule-template",
		displayName: "Schedule Template",
	},
};
